import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import PostService from '../services/PostService';
import { useData } from '../context/DataContext';
import { normalizeImageUrl } from '../utils/imageUtils';

const BlogPage = () => {
    const [posts, setPosts] = useState([]);
    const [blogCategories, setBlogCategories] = useState([]);
    const { postCategories } = useData();
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState('all');
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [totalElements, setTotalElements] = useState(0);
    const pageSize = 9;
    const isFetchingRef = useRef(false);

    const fetchData = async (categoryName, pageNum = 0) => {
        if (isFetchingRef.current) return;
        
        isFetchingRef.current = true;
        setLoading(true);
        try {
            const apiCategory = categoryName === 'all' ? '' : categoryName;
            const postsRes = await PostService.getBlogs(pageNum, pageSize, apiCategory);
            
            let allPosts = [];
            const postsData = postsRes?.data;
            if (Array.isArray(postsData)) {
                allPosts = postsData;
                setTotalPages(1);
                setTotalElements(postsData.length);
            } else if (postsData) {
                allPosts = postsData.content || postsData.items || postsData.data || [];
                setTotalPages(postsData.totalPages || 1);
                setTotalElements(postsData.totalElements || allPosts.length);
            }
            
            setPosts(allPosts);
        } catch (err) {
            console.error('Error fetching blog category:', err);
        } finally {
            setLoading(false);
            isFetchingRef.current = false;
        }
    };

    // 1. Đồng bộ danh mục Blog từ dữ liệu chung
    useEffect(() => {
        if (postCategories && postCategories.length > 0) {
            const blogCats = postCategories.filter(c => c.title === 'BLOG' || c.parentName === 'BLOG');
            setBlogCategories(blogCats);
        }
    }, [postCategories]);

    // Reset page to 0 when category changes
    const handleCategoryChange = (catName) => {
        if (activeCategory !== catName) {
            setActiveCategory(catName);
            setCurrentPage(0);
        }
    };

    // Fetch data when category or page changes
    useEffect(() => {
        if (postCategories && postCategories.length > 0) {
            fetchData(activeCategory, currentPage);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [activeCategory, currentPage, postCategories]);

    const filteredPosts = posts;

    return (
        <main style={{ paddingBottom: 60, borderBottom: '1px solid #ececec' }}>
            {/* ════ MINIMAL BREADCRUMBS ════ */}
            <div className="py-4 mt-[50px]">
                <div className="container px-4">
                    <nav aria-label="breadcrumb">
                        <ol className="flex items-center gap-2 text-xs md:text-sm uppercase tracking-wider mb-0 p-0 list-none">
                            <li className="breadcrumb-item">
                                <Link to="/" className="hover:text-red-600 transition-colors no-underline text-slate-500">Trang chủ</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item active text-slate-900 font-bold" aria-current="page">
                                Blog
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container">
                {/* Tiêu đề */}
                <h1 className="heading-primary text-center" style={{ margin: '0 0 32px' }}>
                    <span>Blog Trung Anh Garage</span>
                </h1>

                {/* Filter tabs theo danh mục */}
                {blogCategories.length > 0 && (
                    <div style={{
                        background: '#fff',
                        borderRadius: 16,
                        boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
                        marginBottom: 40,
                        padding: '0 8px',
                        overflowX: 'auto',
                        scrollbarWidth: 'none',
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: 'max-content',
                        }}>
                            {/* Nút Tất cả */}
                            <button
                                onClick={() => handleCategoryChange('all')}
                                style={{
                                    padding: '16px 22px',
                                    border: 'none',
                                    background: 'none',
                                    cursor: 'pointer',
                                    fontSize: 13,
                                    fontWeight: activeCategory === 'all' ? 800 : 600,
                                    color: activeCategory === 'all' ? '#ff0000' : '#666',
                                    borderBottom: activeCategory === 'all' ? '3px solid #ff0000' : '3px solid transparent',
                                    transition: 'all 0.2s',
                                    whiteSpace: 'nowrap',
                                    flexShrink: 0,
                                }}
                                onMouseEnter={e => { if (activeCategory !== 'all') e.currentTarget.style.color = '#ff0000'; }}
                                onMouseLeave={e => { if (activeCategory !== 'all') e.currentTarget.style.color = '#666'; }}
                            >
                                🗂 Tất cả
                            </button>

                            {/* Divider dọc */}
                            <div style={{ width: 1, height: 20, background: '#eee', flexShrink: 0 }} />

                            {blogCategories.map((cat, idx) => (
                                <React.Fragment key={cat._id || cat.id}>
                                    <button
                                        onClick={() => handleCategoryChange(cat.name)}
                                        style={{
                                            padding: '16px 22px',
                                            border: 'none',
                                            background: 'none',
                                            cursor: 'pointer',
                                            fontSize: 13,
                                            fontWeight: activeCategory === cat.name ? 800 : 600,
                                            color: activeCategory === cat.name ? '#ff0000' : '#666',
                                            borderBottom: activeCategory === cat.name ? '3px solid #ff0000' : '3px solid transparent',
                                            transition: 'all 0.2s',
                                            whiteSpace: 'nowrap',
                                            flexShrink: 0,
                                        }}
                                        onMouseEnter={e => { if (activeCategory !== cat.name) e.currentTarget.style.color = '#ff0000'; }}
                                        onMouseLeave={e => { if (activeCategory !== cat.name) e.currentTarget.style.color = '#666'; }}
                                    >
                                        {cat.name}
                                    </button>
                                    {idx < blogCategories.length - 1 && (
                                        <div style={{ width: 1, height: 20, background: '#eee', flexShrink: 0 }} />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                )}


                {/* Danh sách bài viết */}
                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-danger" role="status" />
                        <p className="mt-3 text-muted">Đang tải bài viết...</p>
                    </div>
                ) : filteredPosts.length === 0 ? (
                    <div className="text-center py-5">
                        <p className="text-muted" style={{ fontSize: 16 }}>Chưa có bài viết nào.</p>
                    </div>
                ) : (
                    <>
                        <div className="row g-4">
                            {filteredPosts.map(post => (
                                <div key={post._id || post.id} className="col-12 col-md-6 col-lg-4">
                                    <div
                                        style={{
                                            background: '#fff', borderRadius: 12, overflow: 'hidden',
                                            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                            transition: 'transform 0.2s, box-shadow 0.2s',
                                            height: '100%', display: 'flex', flexDirection: 'column',
                                        }}
                                        onMouseEnter={e => {
                                            e.currentTarget.style.transform = 'translateY(-4px)';
                                            e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.14)';
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
                                        }}
                                    >
                                        {/* Thumbnail */}
                                        <Link to={`/blog/${post.slug || post._id || post.id}`} style={{ display: 'block', textDecoration: 'none' }}>
                                            <div style={{ height: 200, overflow: 'hidden', background: '#f5f5f5' }}>
                                                {post.imageUrl ? (
                                                    <img
                                                        src={normalizeImageUrl(post.imageUrl)}
                                                        alt={post.title}
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }}
                                                        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                                                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                    />
                                                ) : (
                                                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: 48 }}>📰</div>
                                                )}
                                            </div>
                                        </Link>

                                        {/* Category badge */}
                                        {post.category && (
                                            <div style={{ padding: '10px 20px 0' }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: '#ff0000', background: '#fff5ec', borderRadius: 999, padding: '3px 10px', border: '1px solid #ffe0c2' }}>
                                                    {post.category}
                                                </span>
                                            </div>
                                        )}

                                        {/* Content */}
                                        <div style={{ padding: '12px 20px 20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                            <div style={{ fontSize: 12, color: '#aaa', marginBottom: 6 }}>
                                                {post.createdAt ? new Date(post.createdAt).toLocaleDateString('vi-VN') : ''}
                                            </div>
                                            <Link to={`/blog/${post.slug || post._id || post.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                <h3
                                                    style={{
                                                        fontSize: 16, fontWeight: 700, color: '#222',
                                                        lineHeight: 1.5, marginBottom: 10,
                                                        display: '-webkit-box', WebkitLineClamp: 2,
                                                        WebkitBoxOrient: 'vertical', overflow: 'hidden',
                                                    }}
                                                    onMouseEnter={e => e.currentTarget.style.color = '#ff0000'}
                                                    onMouseLeave={e => e.currentTarget.style.color = '#222'}
                                                >
                                                    {post.title}
                                                </h3>
                                            </Link>
                                            {post.description && (
                                                <p style={{ fontSize: 14, color: '#666', lineHeight: 1.6, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', flex: 1 }}>
                                                    {post.description}
                                                </p>
                                            )}
                                            <Link
                                                to={`/blog/${post.slug || post._id || post.id}`}
                                                style={{ display: 'inline-block', marginTop: 14, color: '#ff0000', fontWeight: 700, fontSize: 13, textDecoration: 'none' }}
                                            >
                                                Xem thêm →
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Phân trang */}
                        {totalPages > 1 && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 40 }}>
                                <button
                                    onClick={() => setCurrentPage(p => Math.max(0, p - 1))}
                                    disabled={currentPage === 0}
                                    style={{
                                        padding: '8px 16px',
                                        borderRadius: 8,
                                        border: '1px solid #ddd',
                                        background: currentPage === 0 ? '#f5f5f5' : '#fff',
                                        cursor: currentPage === 0 ? 'not-allowed' : 'pointer',
                                        fontWeight: 600,
                                        fontSize: 13,
                                        color: currentPage === 0 ? '#aaa' : '#333',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    ← Trước
                                </button>

                                {Array.from({ length: totalPages }, (_, i) => (
                                    <button
                                        key={i}
                                        onClick={() => setCurrentPage(i)}
                                        style={{
                                            width: 36,
                                            height: 36,
                                            borderRadius: 8,
                                            border: currentPage === i ? 'none' : '1px solid #ddd',
                                            background: currentPage === i ? '#ff0000' : '#fff',
                                            color: currentPage === i ? '#fff' : '#333',
                                            fontWeight: 700,
                                            fontSize: 14,
                                            cursor: 'pointer',
                                            transition: 'all 0.2s'
                                        }}
                                    >
                                        {i + 1}
                                    </button>
                                ))}

                                <button
                                    onClick={() => setCurrentPage(p => Math.min(totalPages - 1, p + 1))}
                                    disabled={currentPage >= totalPages - 1}
                                    style={{
                                        padding: '8px 16px',
                                        borderRadius: 8,
                                        border: '1px solid #ddd',
                                        background: currentPage >= totalPages - 1 ? '#f5f5f5' : '#fff',
                                        cursor: currentPage >= totalPages - 1 ? 'not-allowed' : 'pointer',
                                        fontWeight: 600,
                                        fontSize: 13,
                                        color: currentPage >= totalPages - 1 ? '#aaa' : '#333',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    Sau →
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </main>
    );
};

export default BlogPage;



